module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/eliminar-pill-cm.d424b859.svg";